module.exports = __webpack_public_path__ + "img/doc.ed6c5f09.svg";